import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { CaseService } from "../../../services/CaseService";
import moment from "moment";
import CustomSwitch from "../../../components/CustomSwitch";
import { storeActivityIndicator, storeFastFirm } from "../../../redux/reducers/authSlice";
import { CompanyService } from "../../../services/CompanyService";
import toast from "react-hot-toast";
import { CaseMovementService } from "../../../services/CaseMovementService";
import { Helpers } from "../../../helpers/Helpers";
import { GetCaseMovementByIdResponse } from "../../../models/response/caseMovement/GetCaseMovementByIdResponse";
import { AddCaseMovementResponse } from "../../../models/response/caseMovement/AddCaseMovementResponse";

const CaseMovementAdd = () => {
    const navigate = useNavigate();
    const pageName = "Ön Muhasebe > İşlemler > Kasa Hareketleri"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [caseMovementId, setCaseMovementId] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);
    const [selectedCaseMovementType, setSelectedCaseMovementType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCurrentCompany, setSelectedCurrentCompany] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [selectedCase, setSelectedCase] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [price, setPrice] = useState<string | undefined>(undefined);
    const [processDate, setProcessDate] = useState<string | undefined>(moment(new Date()).format("YYYY-MM-DD"));
    const [desc, setDesc] = useState<string | undefined>(undefined);
    const [refNo, setRefNo] = useState<string | undefined>(undefined);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetCaseMovementByIdResponse = await CaseMovementService.getCaseMovementById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCaseMovementId(response.data.caseMovementId);
                setRefNo(response.data.refNo);

                if (response.data.caseMovementTypeId)
                    setSelectedCaseMovementType({ label: response.data.caseMovementTypeName, value: response.data.caseMovementTypeId, additionalValue1: response.data.caseMovementTypeKey })

                if (response.data.caseId)
                    setSelectedCase({ label: response.data.caseName, value: response.data.caseId });

                setPrice(response.data.price.toFixed(2));

                if (response.data.currentCompanyId)
                    setSelectedCurrentCompany({ label: response.data.currentCompanyName, value: response.data.currentCompanyId });

                setDesc(response.data.description);

                setProcessDate(response.data.processDate);
                setIsCustomActive(response.data.isCustomActive);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveCaseMovement = async () => {
        try {
            if (!selectedCaseMovementType)
                toast.error('Hareket Tipi alanını doldurunuz!')
            else if (!selectedCase)
                toast.error('Kasa alanını doldurunuz!')
            else if (Helpers.isEmpty(price))
                toast.error('Tutar alanını doldurunuz!')
            else if (Helpers.isEmpty(processDate))
                toast.error('İşlem Tarihi alanını doldurunuz!')
            else if (selectedCaseMovementType && selectedCaseMovementType.additionalValue1 == "1" && !selectedCurrentCompany)
                toast.error('Firma alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddCaseMovementResponse = await CaseMovementService.addCaseMovement(caseMovementId, refNo, selectedCaseMovementType.value, selectedCase.value, price, processDate, desc, isCustomActive ? 1 : 0, selectedCurrentCompany?.value);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <Box gap="20px" flexDirection="row">
                                    <Box flex={1}>
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Hareket Tipi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCaseMovementType}
                                                onChange={(selectedValue) => {
                                                    setSelectedCaseMovementType(selectedValue);
                                                    setSelectedCurrentCompany(undefined);
                                                }}
                                                onMenuOpen={() => ConstantService.getConstantList('CASE_MOVEMENT_TYPE')}
                                                labelName='value'
                                                valueName='constantId'
                                                additionalValue1Name="additionalValue1"
                                            />
                                        </div>

                                        {
                                            (selectedCaseMovementType && selectedCaseMovementType.additionalValue1 == "1") && (
                                                <div className="mt-5">
                                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Firma</label>

                                                    <CustomSingleSelect
                                                        selectedValue={selectedCurrentCompany}
                                                        onChange={(selectedValue) => {
                                                            setSelectedCurrentCompany(selectedValue);
                                                        }}
                                                        insertable={{
                                                            tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                                            onClick: () => {
                                                                dispatch(storeFastFirm({
                                                                    companyId: selectedCurrentCompany?.value,
                                                                    isCustomer: true,
                                                                    isAgency: true,
                                                                    isSupplier: true,
                                                                    onSubmit: async (response) => {
                                                                        setSelectedCurrentCompany({ label: response.name, value: response.companyId })
                                                                    }
                                                                }))
                                                            }
                                                        }}
                                                        onMenuOpen={[
                                                            () => CompanyService.getCompanyList({ isCustomer: true }),
                                                            () => CompanyService.getCompanyList({ isAgency: true }),
                                                            () => CompanyService.getCompanyList({ isSupplier: true }),
                                                        ]}
                                                        labelName='name'
                                                        valueName='companyId'
                                                    />
                                                </div>
                                            )
                                        }

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">İşlem Tarihi</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={processDate} onChange={(e) => setProcessDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                        </div>
                                    </Box>

                                    <Box flex={1}>
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Kasa</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCase}
                                                onChange={setSelectedCase}
                                                onMenuOpen={() => CaseService.getCaseList()}
                                                labelName='name'
                                                valueName='caseId'
                                            />
                                        </div>

                                        <Box flex={1} className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>

                                            <Box flex={1}>
                                                <textarea value={desc} onChange={(e) => setDesc(e.target.value)} style={{ border: '1px solid #F1F1F4', width: '100%', height: selectedCaseMovementType && selectedCaseMovementType.additionalValue1 == "1" ? '100%' : '1px', resize: 'none' }} className="form-control form-control-solid" />
                                            </Box>
                                        </Box>
                                    </Box>

                                    <Box flex={1}>
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Tutar</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={price} onChange={(e) => setPrice(e.target.value)} type="number" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Aktif</label>

                                            <CustomSwitch isActive={isCustomActive} setIsActive={setIsCustomActive} />
                                        </div>
                                    </Box>
                                </Box>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveCaseMovement}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CaseMovementAdd;